/* tslint:disable */
/* eslint-disable */
/**
 * external-information-requests
 * Medicaid Pending document requests to family members, with the staff workspace and the family portal
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const ParticipantRelationship = {
    Self: 'self',
    Spouse: 'spouse',
    Child: 'child',
    Sibling: 'sibling',
    LegalRepresentative: 'legal_representative',
    PowerOfAttorney: 'power_of_attorney',
    Friend: 'friend',
    Other: 'other',
} as const;
export type ParticipantRelationship = typeof ParticipantRelationship[keyof typeof ParticipantRelationship];


export function instanceOfParticipantRelationship(value: any): boolean {
    for (const key in ParticipantRelationship) {
        if (Object.prototype.hasOwnProperty.call(ParticipantRelationship, key)) {
            if (ParticipantRelationship[key as keyof typeof ParticipantRelationship] === value) {
                return true;
            }
        }
    }
    return false;
}

export function ParticipantRelationshipFromJSON(json: any): ParticipantRelationship {
    return ParticipantRelationshipFromJSONTyped(json, false);
}

export function ParticipantRelationshipFromJSONTyped(json: any, ignoreDiscriminator: boolean): ParticipantRelationship {
    return json as ParticipantRelationship;
}

export function ParticipantRelationshipToJSON(value?: ParticipantRelationship | null): any {
    return value as any;
}

export function ParticipantRelationshipToJSONTyped(value: any, ignoreDiscriminator: boolean): ParticipantRelationship {
    return value as ParticipantRelationship;
}

